"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const parser_1 = require("./parser");
exports.parseInput = (text) => {
    const parser = new parser_1.ChiboParser();
    const lexResult = parser_1.ChiboLexer.tokenize(text);
    // setting a new input will RESET the parser instance's state.
    parser.input = lexResult.tokens;
    // any top level rule may be used as an entry point
    const ast = parser.ProgramRoot();
    if (parser.errors.length > 0) {
        console.error(parser.errors);
    }
    return ast;
};
